import { render, staticRenderFns } from "./TaskAction.vue?vue&type=template&id=134a5af0&"
import script from "./TaskAction.vue?vue&type=script&lang=js&"
export * from "./TaskAction.vue?vue&type=script&lang=js&"
import style0 from "./TaskAction.vue?vue&type=style&index=0&id=134a5af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports